var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeeCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3uk774dnoa",
    width: "183.3%",
    height: "179.5%",
    x: "-41.7%",
    y: "-39.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#3uk774dnoa)",
    transform: "translate(-747 -693) translate(615 698) translate(139)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2,
    d: "M34 19v5c0 3.42-1.072 6.588-2.9 9.188-1.846 2.628-4.463 4.675-7.522 5.813H11.422c-3.06-1.138-5.676-3.185-7.523-5.813C2.072 30.588 1 27.42 1 24v-5c0-.276.112-.526.293-.707.18-.181.43-.293.707-.293h31c.276 0 .526.112.707.293.181.18.293.43.293.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D44",
    fillRule: "nonzero",
    d: "M22.891 7.98l-.486-.587c-.713-.863-.714-2.07-.002-2.933.32-.39.253-.956-.151-1.265-.404-.309-.991-.244-1.312.146-1.255 1.524-1.253 3.651.005 5.174l.485.587c.932 1.128.934 2.705.004 3.834l-.498.605c-.32.389-.253.955.15 1.264.173.131.377.195.58.195.276 0 .548-.117.733-.34l.497-.605c1.474-1.79 1.472-4.287-.005-6.074zM12.891 7.98l-.486-.587c-.713-.863-.714-2.07-.002-2.933.32-.39.253-.956-.151-1.265-.404-.309-.991-.244-1.312.146-1.255 1.524-1.253 3.651.005 5.174l.485.587c.932 1.128.934 2.705.004 3.834l-.498.605c-.32.389-.253.955.15 1.264.173.131.377.195.58.195.276 0 .548-.117.733-.34l.497-.605c1.474-1.79 1.472-4.287-.005-6.074zM17.891 4.98l-.486-.587c-.713-.863-.714-2.07-.002-2.933.32-.39.253-.956-.151-1.265-.404-.309-.991-.244-1.312.146-1.255 1.524-1.253 3.651.005 5.174l.485.587c.932 1.128.934 2.705.004 3.834l-.498.605c-.32.389-.253.955.15 1.264.173.131.377.195.58.195.276 0 .548-.117.733-.34l.497-.605c1.474-1.79 1.472-4.287-.005-6.074z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    x: 7,
    y: 16,
    fill: "#E05C55",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E05C55",
    stroke: "#E05C55",
    strokeWidth: 2,
    d: "M10.964 27.567l-5.547.37-.374-4.607 2.985-2.123 2.763 1.776.173 4.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#2D2D44",
    strokeWidth: 2,
    d: "M28.646 43H6.354c-.838 0-1.64-.237-2.327-.661-.687-.425-1.258-1.036-1.633-1.786l-.724-1.45L33.289 39l-.694 1.573c-.375.74-.941 1.345-1.622 1.766-.686.424-1.489.661-2.327.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D44",
    d: "M41 20c.552 0 1 .448 1 1v6.5c0 3.59-2.91 6.5-6.5 6.5h-4.629l.871-2H35c2.689 0 4.882-2.122 4.995-4.783L40 27v-4c0-.513-.386-.936-.883-.993L39 22h-5.063l.025-2H41z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2D2D44",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M29.5 24.5c-.078 2.162-.553 3.982-1.427 5.46-.874 1.48-1.898 2.66-3.073 3.54"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeCup);
export default __webpack_public_path__ + "static/media/coffee-cup.b6cbd0f3894e5509d476a3f586a0ec44.svg";
export { ForwardRef as ReactComponent };